module.exports = __webpack_public_path__ + "static/media/Camera.292d3245.svg";